import React from 'react';

interface ILeftSectionProps {
    children?: React.ReactNode;
}

const LeftSection: React.FC<ILeftSectionProps> = ({ children }) => (
    <div className="content-page__side content-page__side--left">{children}</div>
);

export default LeftSection;
